/**
 * 자산 검색을 위한 공통 필터 함수 생성
 *
 * @description
 * name, fullyQualifiedName, description 필드를 기준으로 검색하는 필터 함수를 생성합니다.
 * 대소문자를 구분하지 않습니다.
 *
 * @template T - 자산 타입 (name, fullyQualifiedName, description? 필드 필요)
 * @param item - 검색 대상 자산
 * @param query - 검색 쿼리 문자열
 * @returns 검색 조건에 일치하는지 여부
 *
 * @example
 * ```tsx
 * <DataTable
 *   data={containers}
 *   searchFilter={createAssetSearchFilter}
 * />
 * ```
 */
export const createAssetSearchFilter = <
  T extends {
    name: string;
    fullyQualifiedName: string;
    description?: string;
  },
>(
  item: T,
  query: string
): boolean => {
  const lowerQuery = query.toLowerCase();
  return (
    item.name.toLowerCase().includes(lowerQuery) ||
    item.fullyQualifiedName.toLowerCase().includes(lowerQuery) ||
    (item.description?.toLowerCase().includes(lowerQuery) ?? false)
  );
};
